<ng-template #qrcodecontent>
    <ng-container *ngIf="display">
        <ion-item>
            <div class="thumb-box" slot="start">
                <ion-icon slot="start" name="scan-outline"></ion-icon>
                <ng-container *ngIf="display.amount > 0">
                    <ion-badge uppDataid="ticketqrcode-count-badge" color="danger">{{display.amount}}</ion-badge>
                </ng-container>
            </div>            
            <ion-label>
                {{display.alias || tr('@place_ticket_table') + ": " + display.number}}<br/>
                <span class="small" *ngIf="display.extras === true">{{tr('@place_ticket_filter_table_with_extras')}}</span>
                <span class="small" *ngIf="display.extras !== true">{{tr('@place_ticket_filter_table_without_extras')}}</span>
            </ion-label>
        </ion-item>    
    </ng-container>
</ng-template>

<upp-visible-control mode="content">
    <ng-container [ngTemplateOutlet]="qrcodecontent"></ng-container>
</upp-visible-control>
